import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';
import LoadingScreen from './components/LoadingScreen';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import VotingForm from './components/VotingForm';
import PhotoUpload from './components/PhotoUpload';
import NicknameForm from './components/NicknameForm';
import Results from './components/Results';
import NomineeManagement from './components/NomineeManagement';
import CategoryManagement from './components/CategoryManagement';
import { AuthProvider, useAuth } from './services/AuthContext';

const AppContainer = styled.div`
  min-height: 100vh;
`;

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simular carga inicial
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthProvider>
        <AppContainer>
          <Router>
            <AppRoutes />
          </Router>
        </AppContainer>
      </AuthProvider>
    </ThemeProvider>
  );
}

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} 
      />
      <Route 
        path="/dashboard" 
        element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/nominees" 
        element={isAuthenticated ? <NomineeManagement /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/categories" 
        element={isAuthenticated ? <CategoryManagement /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/vote" 
        element={isAuthenticated ? <VotingForm /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/upload-photo" 
        element={isAuthenticated ? <PhotoUpload /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/nickname" 
        element={isAuthenticated ? <NicknameForm /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/results" 
        element={isAuthenticated ? <Results /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/" 
        element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} 
      />
    </Routes>
  );
}

export default App;